import '../datadog';
import '../hotjar-init';

import { createElement } from 'react';
import { createRoot } from 'react-dom/client';

import { Layout } from '../components/page/Layout';
import { camelCaseKeys } from './changeCase';

type ReactComponent = Parameters<typeof createElement>[0];
type ReactProps = Parameters<typeof createElement>[1];

declare global {
  interface Window {
    pageProps: ReactProps;
  }
}

export function renderPageComponent(Page: ReactComponent, camelizeKeys = true, withLayout = true): void {
  const page = withLayout ? (
    <Layout>
      <Page {...(camelizeKeys ? camelCaseKeys(window.pageProps) : window.pageProps)} />
    </Layout>
  ) : (
    <Page {...(camelizeKeys ? camelCaseKeys(window.pageProps) : window.pageProps)} />
  );
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const root = createRoot(document.getElementById('react-mount')!);
  root.render(page);
}
